import { Center, Code, Stack, Text, Title } from "@mantine/core";
import { AlertCircle } from "lucide-react";
import type { ReactNode } from "react";

import classes from "./StatusScreen.module.css";

export interface StatusScreenProps {
  title: string;
  message: string;
  /** A button or link that gets the user out of this state. */
  action?: ReactNode;
  /** The request id from an error, so support can find the server's log line. */
  reference?: string | undefined;
}

/**
 * A full-page message: not found, no team yet, an error the user can act on. The live app's error
 * screen: a 48px alert icon in primary, a 24px title, the message and the action, centered.
 */
export function StatusScreen({ title, message, action, reference }: StatusScreenProps) {
  return (
    <Center mih="60vh" p="md">
      <Stack align="center" gap="md" maw={460} ta="center">
        <AlertCircle size={48} strokeWidth={1.5} className={classes.icon} aria-hidden />
        <Title order={1} className={classes.title}>
          {title}
        </Title>
        <Text c="var(--cai-color-text-muted)">{message}</Text>
        {reference === undefined ? null : (
          <Text size="xs" c="var(--cai-color-text-muted)">
            Reference: <Code>{reference}</Code>
          </Text>
        )}
        {action}
      </Stack>
    </Center>
  );
}
